import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {addToCart, removeFromCart, updateCanvasCount} from "../../../actions/actionFunctions";
import {setLookActiveCategory} from "../../../actions/lookFunctions";
import {setLookRemovedCartItems} from "../../../actions/shoppingCartFunctions";
import {getCartItemsArrayFromFeature} from "../lookNavigation/lookFunctions2";
import {setWizardSqftCartItems} from "../../../actions/wizardFunctions";

const WithUpdateCartItems = (props) => {

  const {cartItems, removeFromCart, addToCart, qtActiveCategory, children, lookRemovedCartItems, setLookRemovedCartItems,
    setWizardSqftCartItems} = props;

  const updateCartItems = (quanItems, wizardSqftCartItems = []) => {
    quanItems.forEach(quanItem => {
      addLookCartItem(quanItem.quanFeature, quanItem.quantity, wizardSqftCartItems)
    });
    if (wizardSqftCartItems.length) {
      addToCart(wizardSqftCartItems);
      setWizardSqftCartItems([]);
    }
  }
  const addLookCartItem = (feature, passedQuantity = null, wizardSqftCartItems = []) => {
    // const urlPartId = feature.partId.replace(/_/gi, "-");
    const featureGroup = feature.getParent();
    let newQuantity = 1;

    const addedCartItem = cartItems.find(cItem => {
      if (featureGroup.layerPositions) {
        return (cItem.partId === feature.partId)
          && (cItem.cartFeature.metaData.layerPosition === feature.metaData.layerPosition)
      }
      return cItem.partId === feature.partId
    });
    if (addedCartItem) {
      removeFromCart(addedCartItem);
      newQuantity = addedCartItem.quantity;
    }
    if (typeof passedQuantity === "number") {
      newQuantity = passedQuantity;
    }
    const itemsToAdd = getCartItemsArrayFromFeature(feature, newQuantity, qtActiveCategory);
    if (wizardSqftCartItems.length) {
      const addedCartItems = wizardSqftCartItems.filter(cItem => {
        return cItem.cartFeature && cItem.cartFeature.dbFeature.groupName === feature.dbFeature.groupName
      });
      if (addedCartItems.length) {
        const allQuantity = addedCartItems.reduce((total, cItem) => total + cItem.quantity, 0);
        // console.log("allQuantity", allQuantity);
        if (allQuantity === newQuantity) {
          return // do not add this feature to cart, it will be added with all sqft features
        }
      }
    }
    addToCart(itemsToAdd);

    if (lookRemovedCartItems.length) {
      let newRemovedCartItems = [...lookRemovedCartItems];
      itemsToAdd.forEach(cartItem => {
        const existingIndex = newRemovedCartItems.findIndex(removedCartItem => {
          if (cartItem.cartFeature.metaData.layerPosition) {
            return (removedCartItem.partId === cartItem.partId)
              && (cartItem.cartFeature.metaData.layerPosition === removedCartItem.cartFeature.metaData.layerPosition)
          }
          return removedCartItem.partId === cartItem.partId
        });
        if (existingIndex > -1) {
          newRemovedCartItems.splice(existingIndex, 1);
        }
      });
      if (newRemovedCartItems.length !== lookRemovedCartItems.length) {
        setLookRemovedCartItems(newRemovedCartItems);
      }
    }
  }

  return children(updateCartItems)
};

const mapStateToProps = (store) => {
  const {cartItems, lookRemovedCartItems} = store.cartState;
  const {qtActiveCategory} = store.qtState;
  const {activePreset} = store.bathroomVisualizerState;
  const {filterGroups} = store.filterState;
  return {
    cartItems,
    qtActiveCategory,
    activePreset,
    lookRemovedCartItems,
    filterGroups,
  }
};

const mapDispatchToProps = {
  removeFromCart,
  addToCart,
  setLookActiveCategory,
  updateCanvasCount,
  setLookRemovedCartItems,
  setWizardSqftCartItems,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithUpdateCartItems)
)
